import { render, staticRenderFns } from "./ScoreDetailsConfigPanel.vue?vue&type=template&id=30a493fc&scoped=true"
import script from "./ScoreDetailsConfigPanel.vue?vue&type=script&lang=js"
export * from "./ScoreDetailsConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./ScoreDetailsConfigPanel.vue?vue&type=style&index=0&id=30a493fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a493fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSlideXTransition,VSpacer,VTextField})
